import React, { useState } from "react";
// import "../StaffView/StaffView.css";

const StaffViewOps = ({ selectedUser }) => {
  const [isEditMode, setIsEditMode] = useState(false);

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  return (
    <div className="container-fluid">
      <br />
      <div className="staffDetail">
        {isEditMode ? (
          <form className="staff-form">
            <table style={{ width: "100%" }}>
              <tbody>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
                <tr className="tableHeading">
                  <td>Full Name*</td>
                  <td>Display Name</td>
                  <td>Status</td>
                </tr>
                <tr>
                  <td>
                    <input
                      placeholder="Enter Please"
                      value={selectedUser?.Name || ""}
                    />
                  </td>
                  <td>
                    <input
                      placeholder="Enter Please"
                      value={selectedUser.Name || ""}
                    />
                  </td>
                  <td style={{ color: "#28A745" }}>
                    <input
                      placeholder="Enter Please"
                      value={selectedUser.Status || "Active"}
                    />
                  </td>
                </tr>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
                <tr className="tableHeading">
                  <td>Gender</td>
                  <td>Email</td>
                  <td>Phone No.</td>
                </tr>

                <tr>
                  <td>
                    <input
                      placeholder="Enter Please"
                      value={selectedUser.Gender || ""}
                    />
                  </td>
                  <td>
                    <input
                      placeholder="Enter Please"
                      value={selectedUser.email || ""}
                    />
                  </td>
                  <td>
                    <input
                      placeholder="Enter Please"
                      value={selectedUser.mobileNo || ""}
                    />
                  </td>
                </tr>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
                <tr className="tableHeading">
                  <td>Designation</td>
                  <td>Region</td>
                </tr>

                <tr>
                  <td>
                    <input
                      placeholder="Enter Please"
                      value={selectedUser.designationName || ""}
                    />
                  </td>
                  <td>
                    <input
                      placeholder="Enter Please"
                      value={selectedUser.Region || ""}
                      disabled
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        ) : (
          <div>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
                <tr className="tableHeading">
                  <td>Full Name</td>
                  <td>Display Name</td>
                  <td>Status</td>
                </tr>

                <tr>
                  <td>{selectedUser.name}</td>
                  <td>{selectedUser.name}</td>
                  <td style={{ color: "#28A745" }}>{selectedUser.Status || "Active"}</td>
                </tr>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
                <tr className="tableHeading">
                  <td>Gender</td>
                  <td>Email</td>
                  <td>Phone No.</td>
                </tr>

                <tr>
                  <td>{selectedUser.Gender || "Male"}</td>
                  <td>{selectedUser.email}</td>
                  <td>{selectedUser.mobileno}</td>
                </tr>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
                <tr className="tableHeading">
                  <td>Designation</td>
                  <td>Region</td>
                </tr>

                <tr>
                  <td>{selectedUser.designationname}</td>
                  <td>{selectedUser.region_name || ""}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
      <br />
    </div>
  );
};

export default StaffViewOps;
